export const MODULE_STATUSES = {
  active: 1,
  inactive: 2,
};
